import React, {useState} from 'react';
import PropTypes from 'prop-types';

const MAX_ITEMS_COLLAPSED = 6

const ModuleCardList = props => {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="d-flex flex-column">
      {props.items.slice(0, collapsed ? -1 : MAX_ITEMS_COLLAPSED)}

      {props.items.length > 6 && <span className="cursor-pointer py-1 mt-1 text-secondary" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? 'Zwiń listę' : 'Rozwiń listę'}
      </span>}
    </div>
  );
};

ModuleCardList.propTypes = {

};

export default ModuleCardList;